import React from "react";
import {useParams} from "react-router-dom";
import Image1920x156 from "../img/thumb/photo-1920x156--2.jpg";
import {Config} from "../Config";
import * as Utils from "../inc/Utils";

export default function OperatingResultsDetail(prop) {
    let {slug} = useParams();

    let [detail, setDetail] = React.useState(null);

    React.useEffect(() => {

        (async function() {
            try {
                const resDetail = await getDetail();
                if(resDetail) {
                    if(prop !== null && prop.lang === 'en') {
                        resDetail.title = resDetail.title_en;
                        resDetail.detail = resDetail.detail_en;
                    }
                    setDetail(resDetail);
                }

            } catch (e) {
                //
            }
        })();
    }, []);

    async function getDetail() {
        const response = await fetch(Config.apiUrl +'operatingResults/viewSlug', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                slug: slug
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section section-banner small">
                <img src={Image1920x156} alt="" />
                <div className="container">
                    <p data-aos="fade-in"><a href={prop.lang === 'en' ? '/en':'/'}>{prop.lang === 'en' ? 'Home':'หน้าแรก'}</a> / <a href={prop.lang === 'en' ? '/en/operating_results':'/operating_results'}>{prop.lang === 'en' ? 'Operating Results':'ผลการดำเนินงานของ ศชวซ.'}</a></p>
                    <h1 className="h2 textrow">
                        <span data-aos="fade-in">{prop.lang === 'en' ? 'Operating Results':'ผลการดำเนินงานของ ศชวซ.'}</span>
                    </h1>
                </div>
            </div>


            <div className="section bg-light">
                <div className="container">
                    <div className="news-details" data-aos="fade-in">
                        <div className="hgroup">
                            <h2>{detail?.title}</h2>
                            <p className="date">{Utils.getDetailDate(detail?.postDate, prop.lang)}</p>
                        </div>

                        <div className="article">
                            {
                                detail?.image ?
                                    <p className="text-center"><img src={Config.fileUpload + 'operating_results/' + detail?.image} alt="" /></p> : ''
                            }
                            <div dangerouslySetInnerHTML={{__html: detail?.detail}}></div>

                            {
                                detail?.file ?
                                    <p>
                                        <a href={Config.fileUpload + 'operating_results/' + detail?.file} target="_blank" className="btn btn-primary">{prop.lang === 'en' ? 'Download PDF':'ดาวน์โหลด PDF'}</a>
                                    </p>  :''
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
} 